import { render, staticRenderFns } from "./SwitchSectionButton.vue?vue&type=template&id=cac7857a&"
import script from "./SwitchSectionButton.vue?vue&type=script&lang=ts&"
export * from "./SwitchSectionButton.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchSectionButton.vue?vue&type=style&index=0&id=cac7857a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports